<template>
  <div class="container-fluid mt-2">
    <div class="btn-toolbar">
      <button @click="save" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
    </div>
    <div class="row mt-3">
      <div class="col-md">
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Service-Mail:</label>
              <input v-model="config['ihand.config.servicemail']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Zusatzfelder:</label>
              <div class="btn-group ml-2">
                <router-link to="/extrafields/0" class="btn btn-secondary">Auftrag</router-link>
                <router-link to="/extrafields/2" class="btn btn-secondary">Auftragsposition</router-link>
                <router-link to="/extrafields/3" class="btn btn-secondary">Neukunden</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>HTML Allgemein:</label>
              <input v-model="config['html.resource.root']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>HTML Kundenberichte:</label>
              <input v-model="config['html.resource.customer']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>HTML Vertreterbereich:</label>
              <input v-model="config['html.resource.handuser']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Passwort für Preiseingabe:</label>
              <input v-model="ipassword"  type="password" class="form-control"/>
              <input v-model="irepeat"    type="password" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-check">
              <input id="livestock" v-model="config['ihand.live.stock']" true-value="1" false-value="0" type="checkbox" class="form-check-input"/>
              <label for="livestock">Live-Lagerdatenabfrage</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-check">
              <input id="fminbuy" v-model="config['ihand.price.minbuy.force']" true-value="1" false-value="0" type="checkbox" class="form-check-input"/>
              <label for="fminbuy">Mindestbestellmenge erzwingen</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-check">
              <input id="fsubmitdlg" v-model="config['ihand.config.ordersubmitdlg']" true-value="1" false-value="0" type="checkbox" class="form-check-input"/>
              <label for="fsubmitdlg">HTML Auftrag-Senden-Dialog (dialogs/orderSubmitPreview.html)</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-check">
              <input id="pdflink" v-model="config['if.proxy.catalog.anrlink']" true-value="1" false-value="0" type="checkbox" class="form-check-input"/>
              <label for="pdflink">PDF Verlinkung mit Artikle-Nr.</label>
            </div>
          </div>
        </div>
        <br/>
      </div>
      <div class="col-md">
        <strong>Lagerampel</strong>&nbsp;&nbsp;<strong>(<a href="/trendshop.proxy.web/help/lagerampel.html" target="_blank">Hilfe</a>)</strong><br/>
        <AceEditor ref="stockScript" :editorId='"stockEditor"' :lang="'javascript'" :content="config['ihand.config.jsstockampel']"/>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import AceEditor from '@/components/AceEditor.vue'

export default {
  name: 'iHandConfig',
  components: {
    AceEditor
  },
  data() {
    return {
      needs: ["ihand.config.jsstockampel","if.proxy.catalog.anrlink","ihand.config.servicemail","html.resource.root","html.resource.customer","ihand.live.stock","html.resource.handuser","ihand.price.minbuy.force","ihand.config.ordersubmitdlg"],
      config: {},
      ipassword: '',
      irepeat: ''
    }
  },
  mounted: function() {
    var self = this;
    config.loadcfg(this.needs,this,function(data) {
      self.config = data;
    })
  },
  methods: {
    save: function() {
      var self = this;
      this.config['ihand.config.jsstockampel'] = this.$refs.stockScript.getContent();
      if (this.ipassword && this.ipassword.length > 0) {
        if (this.ipassword !== this.irepeat) {
          this.$bvToast.toast('iHand Passwort stimmt nicht überein!',{title: 'iHand',variant:'danger'});
          return;
        }
        this.config['ihand.config.pricepass'] = this.ipassword;
      }
      config.savecfg(this.config,this,function() {
        self.$bvToast.toast('Konfiguration gespeichert',{title:'iHand',variant: 'success'});
      })
    }
  }
}
</script>
